"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiKitButton = void 0;
const react_1 = __importDefault(require("react"));
const react_2 = require("@chakra-ui/react");
const UiKitStandardIcon_1 = require("../../components/UiKitStandardIcon");
const galleryIds_1 = require("./galleryIds");
const UiKitButton = (props) => {
    let { bgColor, color, borderColor, w } = props;
    let boxShadow = 'none';
    let minW = w ? w : '8em';
    let iconSpacing = undefined;
    if (props.text === '' && w === undefined) {
        w = props.isSmall ? '24px' : '36px';
        minW = w;
        iconSpacing = 0;
    }
    const focusStyle = { boxShadow: '0 0 0 2px #FFF, 0 0 0 4px #CBE3F1' };
    const hoverAndActiveStyle = props.disabled
        ? {
            bgColor,
            color,
            borderColor,
        }
        : {
            bgColor: props.hoverBgColor,
            color: props.hoverColor,
            borderColor: props.hoverBorderColor,
        };
    if (props.id && galleryIds_1.galleryFocusIds.includes(props.id)) {
        boxShadow = focusStyle.boxShadow;
    }
    if (props.id && (galleryIds_1.galleryHoverIds.includes(props.id) || galleryIds_1.galleryActiveIds.includes(props.id))) {
        ({ bgColor, color, borderColor } = hoverAndActiveStyle);
    }
    const paddingValues = {
        horizontalPadding: '16px',
        verticalPadding: '8px',
    };
    if (props.isSmall) {
        paddingValues.horizontalPadding = '12px';
        paddingValues.verticalPadding = '3px';
    }
    if (props.noPadding) {
        paddingValues.horizontalPadding = '0px';
        paddingValues.verticalPadding = '0px';
    }
    return (react_1.default.createElement(react_2.Button, { _active: hoverAndActiveStyle, _focus: focusStyle, _hover: hoverAndActiveStyle, bgColor: bgColor, borderColor: borderColor, borderWidth: '1px', boxShadow: boxShadow, color: color, "data-cy": props.dataCy ?? null, fontSize: props.isSmall ? '12px' : '14px', fontWeight: props.isBold ? '700' : '500', height: props.isSmall ? '24px' : '36px', iconSpacing: iconSpacing, id: props.id, isActive: props.isActive, isDisabled: props.disabled !== undefined ? props.disabled : false, isLoading: props.isLoading, leftIcon: typeof props.leftIcon === 'string' ? UiKitStandardIcon_1.UiKitStandardIcon[props.leftIcon] : props.leftIcon, loadingText: props.loadingText, m: props.m || '0', minW: minW, onClick: (event) => {
            props.onClick();
            event.stopPropagation();
        }, p: `${paddingValues.verticalPadding} ${paddingValues.horizontalPadding}`, rightIcon: typeof props.rightIcon === 'string' ? UiKitStandardIcon_1.UiKitStandardIcon[props.rightIcon] : props.rightIcon, w: w }, props.text));
};
exports.UiKitButton = UiKitButton;
